<main class="ifc-merge-tools" aria-labelledby="ifcMergeTitle">
  <div class="ifc-merge-tools__layout">
    <nav class="ifc-merge-tools__navigation" aria-labelledby="ifcToolsNavigationTitle">
      <p id="ifcToolsNavigationTitle" class="ifc-merge-tools__eyebrow">Tools</p>
      <div class="ifc-merge-tools__navigation-links">
        <a routerLink="/artifacts">Artifacts</a>
        <a routerLink="/viewer">Viewer</a>
      </div>
    </nav>

    <div class="ifc-merge-tools__content">
      <header class="ifc-merge-tools__header">
        <h1 id="ifcMergeTitle">Merge IFC models</h1>
        <p class="ifc-merge-tools__intro">
          Download a static Python script, then run it locally with the selected IFC files and their transformation
          matrices. Matching IFC schemas are preserved. If schemas differ, the script asks before converting all files
          to IFC4.
        </p>
      </header>

      <section class="ifc-merge-tools__panel" aria-labelledby="ifcMergeInputsTitle">
        <h2 id="ifcMergeInputsTitle">Inputs</h2>
        <label class="ifc-merge-tools__label" for="ifcMergeFiles">IFC files</label>
        <input
          id="ifcMergeFiles"
          class="ifc-merge-tools__file-input"
          type="file"
          accept=".ifc"
          multiple
          [disabled]="ifcMergeInProgress"
          (change)="onIfcMergeFilesChanged($event)"
        />
        <div class="ifc-merge-tools__file-actions">
          <p class="ifc-merge-tools__state">
            {{ ifcMergeItems.length }} files selected. Select more files to add them to the merge.
          </p>
          <button
            *ngIf="ifcMergeItems.length > 0"
            type="button"
            class="ifc-merge-tools__secondary-button"
            [disabled]="ifcMergeInProgress"
            (click)="clearIfcMergeFiles()"
          >
            Clear files
          </button>
        </div>
        <p *ngIf="ifcMergeItems.length > 0 && ifcMergeItems.length < 2" class="ifc-merge-tools__hint" role="status">
          Add at least one more IFC file to generate a merge command.
        </p>

        <label class="ifc-merge-tools__label" for="ifcMergeWorkers">Worker processes</label>
        <input
          id="ifcMergeWorkers"
          class="ifc-merge-tools__number-input"
          type="number"
          min="1"
          step="1"
          [value]="ifcMergeWorkers"
          [disabled]="ifcMergeInProgress"
          (change)="onIfcMergeWorkersChanged($event)"
        />
        <p class="ifc-merge-tools__hint">
          Independent IFC processing and graph assembly can use multiple CPU cores; final graph stitching remains sequential.
        </p>

        <div *ngIf="ifcMergeItems.length > 0" class="ifc-merge-tools__items">
          <article *ngFor="let mergeItem of ifcMergeItems; let index = index" class="ifc-merge-tools__item">
            <h3>{{ mergeItem.file.name }}</h3>
            <div
              class="ifc-merge-tools__matrix"
              role="group"
              [attr.aria-label]="'Transform matrix for ' + mergeItem.file.name"
            >
              <label *ngFor="let value of mergeItem.matrix; let matrixIndex = index">
                m{{ matrixIndex + 1 }}
                <input
                  type="number"
                  step="any"
                  [value]="value"
                  [disabled]="ifcMergeInProgress"
                  (input)="onIfcMergeMatrixChanged(index, matrixIndex, $event)"
                />
              </label>
            </div>
          </article>
        </div>
      </section>

      <section class="ifc-merge-tools__panel" aria-labelledby="ifcMergeCommandTitle">
        <div class="ifc-merge-tools__section-heading">
          <div>
            <p class="ifc-merge-tools__eyebrow">Local execution</p>
            <h2 id="ifcMergeCommandTitle">Run command</h2>
          </div>
          <button
            type="button"
            class="ifc-merge-tools__copy-button"
            [attr.aria-label]="ifcMergeCommandCopied ? 'Command copied' : 'Copy run command'"
            [title]="ifcMergeCommandCopied ? 'Command copied' : 'Copy run command'"
            (click)="copyIfcMergeCommand()"
          >
            {{ ifcMergeCommandCopied ? 'Copied' : 'Copy' }}
          </button>
        </div>
        <textarea
          id="ifcMergeRunCommand"
          class="ifc-merge-tools__command"
          readonly
          rows="5"
          [value]="ifcMergeRunCommand"
          aria-label="Generated macOS run command"
        ></textarea>
        <p class="ifc-merge-tools__hint">
          The downloaded script is static. The command passes each file and its matrix at launch time.
        </p>
        <div *ngIf="ifcMergeError !== null" class="ifc-merge-tools__error" role="alert">{{ ifcMergeError }}</div>
        <div *ngIf="ifcMergeStatusMessage" class="ifc-merge-tools__status" role="status">
          {{ ifcMergeStatusMessage }}
        </div>
        <button
          type="button"
          class="ifc-merge-tools__primary-button"
          [disabled]="ifcMergeInProgress"
          (click)="downloadIfcMergeScript()"
        >
          {{ ifcMergeInProgress ? 'Preparing...' : 'Download static Python script' }}
        </button>
      </section>
    </div>
  </div>
</main>
